module.exports = __webpack_public_path__ + "img/basics1.0d7076fa.png";